function resetScroll() {
	document.querySelector('body').scrollTo(0, -350);
	document.querySelector('html').scrollTo(0, -350);
	document.querySelector('.app').scrollTo(0, -350);
	window.scrollTo(0, -350);
}

export default resetScroll;